import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

const options = {
    defaultSortName: 'kanbans',
    defaultSortOrder: 'asc',
};

const KanbanMatrix = ({ kanbans }) => (
    <BootstrapTable data={kanbans} options={options}>
        <TableHeaderColumn dataField="kanbanId" isKey hidden>
            ID
        </TableHeaderColumn>
        <TableHeaderColumn dataField="kanbans">Kanban</TableHeaderColumn>
        <TableHeaderColumn dataField="numberOfContents" width="150">
            # of boxes
        </TableHeaderColumn>
    </BootstrapTable>
);

export default KanbanMatrix;
